import { Component } from '@angular/core';
import { E5coreUiWorkFieldTypeCurrencyBaseComponent } from './e5core-ui-work-field-type-currency-base';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'e5core-ui-work-field-type-currency-material',
  templateUrl: './e5core-ui-work-field-type-currency-material.component.html',
  styleUrls: ['./e5core-ui-work-field-type-currency-material.component.css']
})
export class E5coreUiWorkFieldTypeCurrencyMaterialComponent extends E5coreUiWorkFieldTypeCurrencyBaseComponent {
  constructor(cp: CurrencyPipe) {
    super(cp) ;
  }
}
